import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 81,
      minHeight: 56,
      paddingTop: 16,
      paddingBottom: 16,
    },
    title: {
      color: variables.richBlack,
      textAlign: 'start',
      fontWeight: 600,
      fontSize: 18,
    },
    subTitle: {
      textAlign: 'left',
      fontWeight: 400,
      fontSize: 16,
      color: variables.black50,
    },
  }),
);
